import { defineMessages } from 'react-intl'

export default defineMessages({
  cancelButton: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  createButton: {
    id: 'Create',
    defaultMessage: 'Create'
  },
  createTitle: {
    id: 'SpaceNotificationSourcePage.CreateNotificationSource',
    defaultMessage: 'Create Notification Source'
  },
  description: {
    id: 'SpaceNotificationSourcePage.NewNotificationSourceDescription',
    defaultMessage: 'Enter a display title and icon which is displayed on a smart notification created by this source.'
  },
  displayTitle: {
    id: 'SpaceNotificationSourcePage.DisplayTitle',
    defaultMessage: 'Display Title'
  },
  displayTitlePlaceholder: {
    id: 'SpaceNotificationSourcePage.DisplayTitle.Placeholder',
    defaultMessage: 'Title that will appear on the notification'
  },
  icon: {
    id: 'SpaceNotificationSourcePage.Icon',
    defaultMessage: 'Icon'
  },
  iconUrl: {
    id: 'SpaceNotificationSourcePage.IconURL',
    defaultMessage: 'Icon'
  },
  iconUrlPlaceholder: {
    id: 'SpaceNotificationSourcePage.IconURL.Placeholder',
    defaultMessage: 'https://www.exampleurl.com/notificationSourceLogo.png'
  },
  invalidImage: {
    id: 'FormError.invalidImage',
    defaultMessage: 'Please enter a valid image URL. Valid image types are gif, jpg, jpeg, and png.'
  },
  invalidUrl: {
    id: 'FormError.InvalidURL',
    defaultMessage: 'Please enter a valid URL.'
  },
  requiredError: {
    id: 'FormError.Required',
    defaultMessage: 'Please enter a value.'
  },
  updateButton: {
    id: 'Update',
    defaultMessage: 'Update'
  },
  updateTitle: {
    id: 'SpaceNotificationSourcePage.UpdateNotificationSource',
    defaultMessage: 'Update Notification Source'
  }
})
